<template>
  <div id="my-support">
    <div class="row reverse-mobile" id="my-contracts">
      <div class="col-12 col-md-3">
        <UserMenu></UserMenu>
      </div>
      <div class="col-12 col-md-9">
        <div class="row mb-4">
          <div class="d-flex flex-row align-items-center">
            <i class="material-icons material-icons-title mr-2">save_alt</i>
            <h2 class="mt-2">Available Downloads</h2>
          </div>
        </div>
        <div class="alert alert-secondary mb-4" role="alert">
          <strong>IMPORTANT INFORMATION</strong>

          <p>
            You will need to perform the following additional steps after
            installing before running the application:
          </p>

          <ul>
            <li>Go to iPad Settings</li>
            <li>Select General</li>
            <li>Select Profile</li>
            <li>iSimulate PTY LTD</li>
            <li>
              Click
              <em>"Trust iSIMULATE PTY LTD"</em>
            </li>
          </ul>

          <div></div>
        </div>
        <div class="row">
          <div class="card">
            <div class="card-body">
              <div class="downloads-container mt-4">
                <div class="col-12 card bg-light">
                  <div
                    class="row download card-body rounded bg-light py-3 d-flex"
                  >
                    <div class="col-2 d-flex align-items-center">
                      <img src="../assets/ctgi-app-icon.png" />
                    </div>
                    <div class="col-6 d-flex align-items-center">
                      <div class>
                        <h5>CTGi 3.10.1</h5>
                        <em>
                          NOTE: This verison needs a valid, unused license
                          supplied by iSimulate.<br />
                          If you are running an old version of CTGi (3.x) you'll
                          need to update it with this download onto your
                          iPads.<br />
                          You can then export your scenarios to your new CTGi
                          which you would have downloaded from the App Store.
                        </em>
                      </div>
                    </div>
                    <div
                      class="col-4 d-flex align-items-center justify-content-end"
                    >
                      <a
                        href="itms-services://?action=download-manifest&url=https://assets.isimulateonline.com/downloads/clients/ctgi/ctgikey3.10.1.plist"
                      >
                        <button
                          class="btn btn-primary d-flex align-items-center justify-content-center my-4"
                        >
                          <i class="material-icons mr-1">cloud_download</i>
                          <span class="button-text">Install</span>
                        </button>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserMenu from "../components/UserMenu";
export default {
  name: "MyDownloads",
  components: {
    UserMenu,
  },
};
</script>

<style scoped>
.download img {
  max-width: 100%;
  height: auto;
}
</style>
